import { Component, ElementRef, inject, signal, ViewChild, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChatService } from '../../../services/chat/chat.service';
import { VoiceService } from '../../../services/voice/voice.service';

@Component({
  selector: 'app-password-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './password-modal.html',
  styleUrl: './password-modal.scss',
})
export class PasswordModal {
  private chatService = inject(ChatService);
  private voiceService = inject(VoiceService);
  private el = inject(ElementRef);

  @ViewChild('passwordInput') passwordInput!: ElementRef<HTMLInputElement>;

  public targetArena = this.chatService.targetLockedArena;
  public password = signal<string>('');
  public errorMessage = signal<string>('');

  constructor() {
    effect(() => {
      if (this.targetArena()) {
        this.password.set('');
        this.errorMessage.set('');
        setTimeout(() => {
          if (this.passwordInput) {
            this.passwordInput.nativeElement.focus();
          }
        }, 300);
      }
    });
  }

  public confirmJoin() {
    const arena = this.targetArena();
    const pwd = this.password().trim();

    if (!arena || !pwd) {
      this.errorMessage.set('Please enter a password.');
      return;
    }

    this.voiceService.disconnect();
    this.chatService.join(arena.guid, pwd);

    this.onCancel();

    const closeBtn = this.el.nativeElement.querySelector('[data-bs-dismiss="modal"]');
    if (closeBtn) {
      closeBtn.click();
    }
  }

  public onCancel() {
    this.password.set('');
    this.errorMessage.set('');
  }
}
